import { concentrations as cct, lowSceneLevel } from '@/utils/dict';
import ctt from '@/utils/const';
import { merge } from 'lodash';
import { ecModRunState, ecModTrend, extECModAlarmName, ecModDeviceState } from './/util/index';
import { pidReduction } from '@/utils/deviceUtils/index';
import { isEmpty } from '@/utils/is';
import { arrify } from '@/utils/utils';

export default {
  data() {
    return {
      radPicInfo: {},
      badgeHidden: true,
      dataLength: 0,
      chartData: {
        CHART_LEFT: {
          deviceState: {
            type: 'sysMod',
            typeName: '设备状态',
            deviceTypes: [
              ctt.FCBR_100PRO,
              ctt.FCBR_100PROGA,
              ctt.FCBR_100_v1,
              ctt.FCBR_100GA,
              ctt.FCBR_100_v2,
              ctt.FCBR_100F,
              ctt.FCBR_100G,
              ctt.FCBR_100CP,
              ctt.FCBR_100C,
              ctt.FCBR_100CV2,
              ctt.FCBR_100B,
              ctt.FCBR_100CFR
            ]
          },
          smoke: {
            type: 'smokeMod',
            typeName: '烟雾浓度',
            deviceTypes: [
              ctt.FCBR_100PRO,
              ctt.FCBR_100PROGA,
              ctt.FCBR_100_v1,
              ctt.FCBR_100GA,
              ctt.FCBR_100_v2,
              ctt.FCBR_100F,
              ctt.FCBR_100G,
              ctt.FCBR_100C,
              ctt.FCBR_100CFR
            ]
          },
          nuclear2: {
            type: 'nuclearMod',
            typeName: '核辐射',
            deviceTypes: [ctt.FCBR_100CFR]
          },
          bioBig: {
            type: 'bioMod',
            typeName: '≥1μm 颗粒',
            deviceTypes: [
              ctt.FCBR_100PRO,
              ctt.FCBR_100PROGA,
              ctt.FCBR_100_v1,
              ctt.FCBR_100GA,
              ctt.FCBR_100_v2,
              ctt.FCBR_100F,
              ctt.FCBR_100G,
              ctt.FCBR_100B
            ]
          },
          bioLittle: {
            type: 'bioMod',
            typeName: '<1μm 颗粒',
            deviceTypes: [
              ctt.FCBR_100PRO,
              ctt.FCBR_100PROGA,
              ctt.FCBR_100_v1,
              ctt.FCBR_100GA,
              ctt.FCBR_100_v2,
              ctt.FCBR_100F,
              ctt.FCBR_100G,
              ctt.FCBR_100B
            ]
          },
          cwa: {
            type: 'cwaMod',
            typeName: '化学战剂',
            deviceTypes: [ctt.FCBR_100C, ctt.FCBR_100CV2]
          },
          ecTIC: { type: 'ecMod', typeName: '二氧化氮/硫化氢', deviceTypes: [ctt.FCBR_100CP] },
          ecCWA: { type: 'ecMod', typeName: '氰化氢/光气', deviceTypes: [ctt.FCBR_100CP] },
          o2: { type: 'ecMod', typeName: '氧气', deviceTypes: [ctt.FCBR_100CP] }
        },
        CHART_RIGHT: {
          tvoc1: {
            type: 'tvocMod',
            typeName: '有毒有害易燃气体指数',
            smoothTimeLineMax: ctt.REAL_DATA_LENGTH,
            smoothTimeLine: true,
            deviceTypes: [
              ctt.FCBR_100PRO,
              ctt.FCBR_100PROGA,
              ctt.FCBR_100_v1,
              ctt.FCBR_100GA,
              ctt.FCBR_100_v2,
              ctt.FCBR_100F,
              ctt.FCBR_100G,
              ctt.FCBR_100CP,
              ctt.FCBR_100C,
              ctt.FCBR_100CV2,
              ctt.FCBR_100B
            ]
          },
          tvoc2: {
            type: 'tvocMod',
            typeName: '氯气/氨气/一氧化碳',
            smoothTimeLineMax: ctt.REAL_DATA_LENGTH,
            smoothTimeLine: true,
            deviceTypes: [
              ctt.FCBR_100PRO,
              ctt.FCBR_100PROGA,
              ctt.FCBR_100_v1,
              ctt.FCBR_100GA,
              ctt.FCBR_100_v2,
              ctt.FCBR_100F,
              ctt.FCBR_100G,
              ctt.FCBR_100CP,
              ctt.FCBR_100C,
              ctt.FCBR_100CV2,
              ctt.FCBR_100B
            ]
          },
          tvoc4: {
            type: 'ecMod',
            typeName: '有毒有害易燃气体指数',
            smoothTimeLineMax: ctt.REAL_DATA_LENGTH,
            smoothTimeLine: true,
            deviceTypes: [ctt.FCBR_100CFR]
          },
          cwa: {
            type: 'cwaMod',
            typeName: '化学战剂',
            smoothTimeLineMax: ctt.REAL_DATA_LENGTH,
            smoothTimeLine: true,
            deviceTypes: [
              ctt.FCBR_100PRO,
              ctt.FCBR_100PROGA,
              ctt.FCBR_100_v1,
              ctt.FCBR_100GA,
              ctt.FCBR_100_v2,
              ctt.FCBR_100F,
              ctt.FCBR_100G,
              ctt.FCBR_100CP,
              ctt.FCBR_100CFR
            ]
          },
          nuclear: {
            type: 'nuclearMod',
            smoothTimeLineMax: ctt.REAL_DATA_LENGTH,
            smoothTimeLine: true,
            typeName: '核辐射',
            deviceTypes: [ctt.FCBR_100PRO, ctt.FCBR_100PROGA]
          },
          gcamera: {
            type: 'gcameraMod',
            typeName: '伽马相机',
            deviceTypes: [ctt.FCBR_100G],
            slot: 'gcamera'
          },
          smokeAd: {
            type: 'smokeMod',
            typeName: '烟雾',
            deviceTypes: [
              ctt.FCBR_100_v1,
              ctt.FCBR_100GA,
              ctt.FCBR_100_v2,
              ctt.FCBR_100F,
              ctt.FCBR_100C
            ]
          },
          smoke: {
            type: 'smokeMod',
            typeName: '烟雾浓度',
            deviceTypes: [ctt.FCBR_100CP, ctt.FCBR_100B]
          }
        }
      },
      pidThreshold: 0
    };
  },
  methods: {
    whichRow(mod) {
      const res = this.tableData.filter(e => e.type === mod);
      return res.length > 1 ? res : res[0];
    },
    updateDeviceStateAndSmoke(newVal) {
      const { sysMod, smokeMod, cwaMod } = newVal.mods;
      if (cwaMod) this.echartObj.deviceState.series[0].data[0].value = cwaMod.flow;
      if (sysMod) this.echartObj.deviceState.series[1].data[0].value = sysMod.mainTemp;
      if (sysMod) this.echartObj.deviceState.series[2].data[0].value = sysMod.mainHumidity;
      if (smokeMod && smokeMod.smokeFault === 1) {
        // 烟雾故障
        this.echartObj.deviceState.series[3].data[0].value = 2;
      } else if (cwaMod && cwaMod.htFault === 1) {
        this.echartObj.deviceState.series[3].data[0].value = 0;
      } else {
        this.echartObj.deviceState.series[3].data[0].value = 1;
      }
      // 烟雾浓度
      const risk = smokeMod && (smokeMod.alarmContent === '无' ? '正常' : smokeMod.alarmContent);
      let value;
      switch (risk) {
        case '正常':
          value = 1;
          break;
        case '警告':
          value = 3;
          break;
        case '报警':
          value = 5;
          break;
        case '烟雾1':
          value = 7;
          break;
        case '烟雾2':
          value = 9;
          break;
        default:
          value = 0;
          break;
      }
      if (this.echartObj.smoke) this.echartObj.smoke.series.data[0].value = value;
      if (this.echartObj.smoke && smokeMod)
        this.echartObj.smoke.series.data[0].trueValue = parseInt(smokeMod.smokeData);
      if (this.echartObj.smoke) this.echartObj.smoke.series.data[0].risk = risk;
    },
    updateTable(newVal) {
      // 更新表格
      const { sysMod, smokeMod, bioMod, tvocMod, cwaMod, nuclearMod, gcameraMod, ecMod } =
        newVal.mods;

      if (ecMod) {
        const { cocl2, h2s, hcn, no2, hcl, nh3, so2, co, ch4 } = ecMod;
        const ecModRow = arrify(this.whichRow('ecMod'));

        if (this.deviceType === ctt.FCBR_100CFR) {
          const val = {
            state: ecModDeviceState(hcl, nh3, so2, co, ch4),
            runstate: ecModRunState([ecMod.runstate]),
            change: ecModTrend([hcl.trend, nh3.trend, so2.trend, co.trend, ch4.trend]),
            cur: `${[hcl.value, nh3.value, so2.value, co.value, ch4.value].join('/')}(PPM)`,
            alarmContent: extECModAlarmName(hcl, nh3, so2, co, ch4)
          };

          Object.assign(ecModRow[0], val);
        } else {
          Object.assign(ecModRow[0], {
            state: ecModDeviceState(no2, h2s),
            runstate: ecModRunState([no2.runstate, h2s.runstate]),
            change: ecModTrend([no2.trend, h2s.trend]),
            cur: `${no2.value}/${h2s.value}(PPM)`,
            alarmContent: extECModAlarmName(no2, h2s)
          });

          Object.assign(ecModRow[1], {
            state: ecModDeviceState(hcn, cocl2),
            runstate: ecModRunState([hcn.runstate, cocl2.runstate]),
            change: ecModTrend([hcn.trend, cocl2.trend]),
            cur: `${hcn.value}/${cocl2.value}(PPM)`,
            alarmContent: extECModAlarmName(hcn, cocl2)
          });
        }
      }
      if (smokeMod) {
        const {
          state: smoketState,
          runstate: smokers,
          trend: smokeTrend,
          smokeData,
          alarmContent: smokeAc
        } = smokeMod;
        let smokeModRow = this.whichRow('smokeMod');
        smokeModRow.cur = smokeData;
        smokeModRow.change = smokeTrend;
        smokeModRow.state = smoketState;
        smokeModRow.runstate = smokers;
        smokeModRow.alarmContent = smokeAc;
      }
      if (bioMod) {
        const {
          state: bioState,
          runstate: biors,
          trend: bioTrend,
          bioAll,
          alarmContent: bioAc
        } = bioMod;
        let bioModRow = this.whichRow('bioMod');
        bioModRow.cur = bioAll + ` (个/升)`;
        bioModRow.change = bioTrend;
        bioModRow.state = bioState;
        bioModRow.runstate = biors;
        bioModRow.alarmContent = bioAc;
      }
      if (tvocMod) {
        const {
          state: tvocState,
          runstate: tvocrs,
          trend: tvocTrend,
          pidValue,
          cl2,
          nh3,
          co,
          alarmContent: tvocAc
        } = tvocMod;
        let tvocModRow = this.whichRow('tvocMod');

        if (tvocModRow) {
          tvocModRow.cur = `${pidReduction(pidValue, 100)}/${cl2}/${nh3}/${co}(PPM)`;
          tvocModRow.change = tvocTrend;
          tvocModRow.state = tvocState;
          tvocModRow.runstate = tvocrs;
          tvocModRow.alarmContent = tvocAc;
        }
      }
      if (cwaMod) {
        const {
          state: cwaState,
          runstate: cwars,
          trend: cwaTrend,
          concentration,
          alarmContent: cwaAc
        } = cwaMod;
        let cwaModRow = this.whichRow('cwaMod');
        cwaModRow.cur = cct[concentration];
        cwaModRow.change = cwaTrend;
        cwaModRow.state = cwaState;
        cwaModRow.runstate = cwars;
        cwaModRow.alarmContent = cwaAc;
      }
      if (sysMod) {
        const {
          state: sysState,
          runstate: sysrs,
          trend: sysTrend,
          mainTemp,
          alarmContent: sysAc
        } = sysMod;
        let sysModRow = this.whichRow('sysMod');
        sysModRow.cur = `${mainTemp + '(℃)'}/${
          cwaMod ? cwaMod.flow + '(L/min)' : '-'
        }/${this.faultRes(smokeMod ? smokeMod.smokeFault : 0, cwaMod ? cwaMod.htFault : 0)}`;
        sysModRow.change = sysTrend;
        sysModRow.state = sysState;
        sysModRow.runstate = sysrs;
        sysModRow.alarmContent = sysAc;
      }
      if (nuclearMod) {
        const {
          state: nuclearState,
          runstate: nuclearrs,
          trend: nuclearTrend,
          radDose,
          radBeta,
          alarmContent: nuclearAc,
          rg04Dto
        } = nuclearMod;

        let nuclearModRow = this.whichRow('nuclearMod');

        if ([ctt.FCBR_100CFR].includes(this.deviceType)) {
          nuclearModRow.mod = '核检测(γ/α/β)';
          nuclearModRow.cur = `${radDose}(uSv/h)/${rg04Dto.alphaProbeValue}(bq/cm²)/${rg04Dto.betaProbeValue}(bq/cm²)`;
        } else {
          nuclearModRow.cur = `${radDose}(uSv/h)/${radBeta}(bq/cm²)`;
        }

        nuclearModRow.change = nuclearTrend;
        nuclearModRow.state = nuclearState;
        nuclearModRow.runstate = nuclearrs;
        nuclearModRow.alarmContent = nuclearAc;
      }
      if (gcameraMod) {
        const {
          state: gcameraState,
          runstate: gcamerars,
          trend: gcameraTrend,
          radDoses,
          alarmContent: gcameraAc
        } = gcameraMod;
        let gcameraModRow = this.whichRow('gcameraMod');
        gcameraModRow.cur = `${radDoses.join('/')}(uSv/h)`;
        gcameraModRow.change = gcameraTrend;
        gcameraModRow.state = gcameraState;
        gcameraModRow.runstate = gcamerars;
        gcameraModRow.alarmContent = gcameraAc;
      }
    },
    updateEchart(newVal) {
      const { isHisDetail, deviceType } = this;
      const { beginTime } = newVal;
      const { smokeMod, bioMod, tvocMod, cwaMod, nuclearMod, gcameraMod, ecMod } = newVal.mods;

      const {
        bioBig,
        bioLittle,
        tvoc1,
        tvoc2,
        tvoc3,
        tvoc4,
        cwa,
        ecTIC,
        ecCWA,
        o2,
        nuclear,
        nuclear2,
        gcamera,
        smokeAd
      } = this.echartObj;

      // 设备状态和烟雾
      if (!isHisDetail) {
        // 非历史预警详情的时候更新
        this.updateDeviceStateAndSmoke(newVal);
        this.dataLength++;
        if (this.dataLength >= ctt.REAL_DATA_LENGTH + 2) {
          this.dataLength--;
          if (bioMod) {
            bioBig?.series[0].data.shift();
            bioBig?.series[1].data.shift();
            bioLittle?.series[0].data.shift();
            bioLittle?.series[1].data.shift();
          }
          if (tvocMod) {
            tvoc1?.series.data.shift();
            tvoc2?.series[0].data.shift();
            tvoc2?.series[1].data.shift();
            tvoc2?.series[2].data.shift();
          }
          if (cwaMod) {
            cwa?.series[0].data.shift();
            cwa?.series[1].data.shift();
          }
          if (ecMod) {
            ecTIC?.series[0].data.shift();
            ecTIC?.series[1].data.shift();
            ecCWA?.series[0].data.shift();
            ecCWA?.series[1].data.shift();
            o2?.series[0].data.shift();

            tvoc3?.series[0].data.shift();
            tvoc3?.series[1].data.shift();
            tvoc3?.series[2].data.shift();
            tvoc3?.series[3].data.shift();
            tvoc3?.series[4].data.shift();

            tvoc4?.series.data.shift();
          }

          if (nuclearMod) {
            if ([ctt.FCBR_100PRO, ctt.FCBR_100PROGA].includes(deviceType)) {
              nuclear.series[0].data.shift();
              nuclear.series[1].data.shift();
            }

            if (ctt.FCBR_100CFR === deviceType) {
              nuclear2.series[0].data.shift();
              nuclear2.series[1].data.shift();
              nuclear2.series[2].data.shift();
            }
          }

          // 包含核模块的设备
          if (
            [ctt.FCBR_100F, ctt.FCBR_100GA, ctt.FCBR_100_v1, ctt.FCBR_100_v2].includes(deviceType)
          ) {
            smokeAd.series.data.shift();
          } else if (deviceType === ctt.FCBR_100G) {
            gcamera.series.forEach(e => {
              e.data.shift();
            });
          }
        }
      }

      if (bioMod) {
        // 生物大颗粒
        bioBig?.series[0].data.push([beginTime, bioMod.bioOrLarge]);
        bioBig?.series[1].data.push([beginTime, bioMod.parOrLarge]);
        // 生物小颗粒
        bioLittle?.series[0].data.push([beginTime, bioMod.bioOrSmall]);
        bioLittle?.series[1].data.push([beginTime, bioMod.parOrSmall]);
      }

      if (ecMod) {
        ecTIC?.series[0].data.push([beginTime, ecMod.no2.value]); // 二氧化氮
        ecTIC?.series[1].data.push([beginTime, ecMod.h2s.value]); // 硫化氢
        ecCWA?.series[0].data.push([beginTime, ecMod.hcn.value]); // 氰化氢
        ecCWA?.series[1].data.push([beginTime, ecMod.cocl2.value]); // 光气
        o2?.series[0].data.push([beginTime, ecMod.o2.value]); // 氧气

        if (!isEmpty(tvoc4)) {
          // FCBR100CFR 设备单独处理
          tvoc4.legend.show = false;

          tvoc4.series.data.push([beginTime, ecMod.pid.value]);
        }

        if (!isEmpty(tvoc3)) {
          tvoc3.series[0].data.push([beginTime, ecMod.hcl.value]);
          tvoc3.series[1].data.push([beginTime, ecMod.nh3.value]);
          tvoc3.series[2].data.push([beginTime, ecMod.so2.value]);
          tvoc3.series[3].data.push([beginTime, ecMod.co.value]);
          tvoc3.series[4].data.push([beginTime, ecMod.ch4.value]);
        }
      }
      if (tvocMod) {
        // 有毒有害易燃气体指数
        if (!isEmpty(tvoc1)) {
          tvoc1.series.data.push([beginTime, pidReduction(tvocMod.pidValue, 100)]);
        }

        // 氯气氨气一氧化碳
        if (!isEmpty(tvoc2)) {
          tvoc2.series[0].data.push([beginTime, tvocMod.cl2]);
          tvoc2.series[1].data.push([beginTime, tvocMod.nh3]);
          tvoc2.series[2].data.push([beginTime, tvocMod.co]);
        }
      }
      if (cwaMod) {
        // 化学战剂
        if (!isEmpty(cwa)) {
          cwa.series[0].data.push([beginTime, cwaMod.sccell1RData]);
          cwa.series[1].data.push([beginTime, cwaMod.sccell2RData]);
        }
      }

      if (nuclearMod) {
        if (!isEmpty(nuclear)) {
          nuclear.series[0].data.push([beginTime, nuclearMod.radDose]);
          nuclear.series[1].data.push([beginTime, nuclearMod.radBeta]);
        }

        if (
          !isEmpty(nuclear2) &&
          !isEmpty(nuclearMod.rg04Dto?.alphaProbeValue) &&
          !isEmpty(nuclearMod.rg04Dto?.betaProbeValue)
        ) {
          nuclear2.series[0].data.push([beginTime, nuclearMod.radDose]);
          nuclear2.series[1].data.push([beginTime, nuclearMod.rg04Dto.alphaProbeValue]);
          nuclear2.series[2].data.push([beginTime, nuclearMod.rg04Dto.betaProbeValue]);
        }
      }
      if (gcameraMod) {
        // 伽马相机
        if (gcamera) {
          if (gcameraMod.radPicId) this.radPicInfo = { id: gcameraMod.radPicId, beginTime };
          gcamera.series[0].data.push([beginTime, gcameraMod.radDoses[0]]);
          gcamera.series[1].data.push([beginTime, gcameraMod.radDoses[1]]);
        }
      }
      if (smokeMod && smokeAd) {
        smokeAd.series.data.push([beginTime, smokeMod.smokeData]);
      }
    },
    updateThreshold(newVal) {
      if (newVal.paramItems && !newVal.paramItems.length) return;
      // 获取当前使用场景的 pidThreshold 值
      const pidThreshold = newVal.paramItems.find(e => e.itemCode === 'pidThreshold');
      if (!pidThreshold) return;
      const pidThresholdValue = pidThreshold.value[lowSceneLevel[newVal.sceneCurrent]];
      const ptd = pidReduction(pidThresholdValue, 100);
      this.pidThreshold = ptd;

      const { tvoc1 } = this.echartObj;

      if (!isEmpty(tvoc1)) {
        this.echartObj.tvoc1 = merge(tvoc1, {
          series: {
            markLine: {
              data: [
                {
                  name: '阈值',
                  yAxis: ptd,
                  lineStyle: {
                    color: '#FF4847'
                  }
                }
              ]
            }
          },
          visualMap: {
            type: 'piecewise',
            top: 0,
            right: 10,
            orient: 'horizontal',
            textGap: 5,
            itemWidth: 14,
            itemHeight: 10,
            pieces: [
              { gt: -1, lte: ptd, color: '#03b36e', label: `0 - ${ptd}` },
              { gt: ptd, color: '#FF4847' }
            ],
            outOfRange: {
              color: '#FF4847'
            },
            textStyle: {
              color: '#00eeff',
              fontSize: 10
            }
          }
        });
      }
    }
  }
};
